if (!customElements.get('lyra-pair-it-with')) {
  customElements.define(
    'lyra-pair-it-with',
    class LyraPairItWith extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.productInfo = this.closest('product-info');
        this.handleProductOptionChange = this.handleProductOptionChange.bind(this);

        this.load();
        this.productInfo?.addEventListener('change', this.handleProductOptionChange);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.handleProductOptionChange);
      }

      async load() {
        try {
          const response = await fetch(`${this.dataset.url}&product_id=${this.dataset.productId}`);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const source = html.querySelector(
            `lyra-pair-it-with[data-block-id="${this.dataset.blockId}"] .lyra-pair-it-with__content`
          );

          if (!source) {
            this.remove();
            return;
          }

          this.innerHTML = source.outerHTML;
          this.hidden = false;
          this.setUpItems();
          this.updateAllItems();
        } catch (error) {
          console.error('Failed to load pair-it-with products', error);
        }
      }

      setUpItems() {
        this.items = Array.from(this.querySelectorAll('[data-pair-product]'));
        this.items.forEach((item) => {
          const dataNode = item.querySelector('.lyra-pair-it-with__product-data');
          if (!dataNode) return;

          try {
            item.productData = JSON.parse(dataNode.textContent);
          } catch (error) {
            console.error('Failed to parse pair-it-with product data', error);
          }
        });
      }

      handleProductOptionChange(event) {
        if (!event.target.closest('variant-selects')) return;
        window.requestAnimationFrame(() => this.updateAllItems());
      }

      updateAllItems() {
        if (!this.items || !this.items.length) return;
        this.items.forEach((item) => this.updateItem(item));
      }

      updateItem(item) {
        const variant = this.resolveVariant(item.productData);
        const variantInput = item.querySelector('input[name="id"]');
        const button = item.querySelector('[data-pair-submit]');
        const label = item.querySelector('[data-pair-label]');

        if (!variantInput || !button || !label) return;

        if (!variant || !variant.available) {
          variantInput.value = variant?.id || '';
          button.setAttribute('disabled', 'disabled');
          label.innerHTML = '<span class="lyra-pair-it-with__soldout-only">Sold out</span>';
          return;
        }

        variantInput.value = variant.id;
        button.removeAttribute('disabled');

        let addWord = label.querySelector('[data-pair-add-word]');
        let priceEl = label.querySelector('[data-pair-price]');
        if (!addWord || !priceEl) {
          label.innerHTML =
            '<span class="lyra-pair-it-with__add-word" data-pair-add-word>ADD</span>' +
            '<span class="lyra-pair-it-with__btn-price-sep" aria-hidden="true"> </span>' +
            '<span class="lyra-pair-it-with__btn-price" data-pair-price></span>';
          addWord = label.querySelector('[data-pair-add-word]');
          priceEl = label.querySelector('[data-pair-price]');
        }
        if (addWord) addWord.textContent = 'ADD';
        if (priceEl && variant.formatted_price) priceEl.textContent = variant.formatted_price;
      }

      resolveVariant(productData) {
        if (!productData || !Array.isArray(productData.variants) || !productData.variants.length) return null;

        const currentColor = this.getCurrentColor();
        const colorOptionIndex = this.getColorOptionIndex(productData.options || []);

        if (currentColor && colorOptionIndex > -1) {
          const optionKey = `option${colorOptionIndex + 1}`;
          const matchingVariant = productData.variants.find(
            (variant) => variant.available && this.normalizeValue(variant[optionKey]) === currentColor
          );

          if (matchingVariant) {
            return matchingVariant;
          }
        }

        return productData.variants.find((variant) => variant.available) || productData.variants[0] || null;
      }

      getCurrentColor() {
        const variantSelects = this.productInfo?.querySelector('variant-selects');
        if (!variantSelects) return null;

        const colorField = variantSelects.querySelector(
          '[data-handle="color"], [data-handle="colour"], [data-handle="colore"]'
        );

        if (!colorField) return null;

        const checkedInput = colorField.querySelector('input[type="radio"]:checked');
        if (checkedInput?.value) return this.normalizeValue(checkedInput.value);

        const selectedOption = colorField.querySelector('option[selected], option:checked');
        if (selectedOption?.value) return this.normalizeValue(selectedOption.value);

        const selectedValue = colorField.querySelector('[data-selected-value]');
        if (selectedValue?.textContent) return this.normalizeValue(selectedValue.textContent);

        return null;
      }

      getColorOptionIndex(options) {
        return options.findIndex((optionName) => {
          const normalizedName = this.normalizeValue(optionName);
          return ['color', 'colour', 'colore'].includes(normalizedName);
        });
      }

      normalizeValue(value) {
        return String(value || '')
          .trim()
          .toLowerCase();
      }
    }
  );
}
